import { useIntl } from "react-intl";

import { Button } from "../../components/atoms/button";
import { useFormContext } from "../../components/form";
import { TextField } from "../../components/form/fields/text-field";
import { FileInputLayoutGroup } from "../../components/form/layout/groups/file-input-layout-group";
import { type SentryErrorFeedbackValues } from "../schemas/sentry-error-feedback";

export function SentryErrorFeedbackFormFields() {
  const intl = useIntl();
  const {
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useFormContext<SentryErrorFeedbackValues>();

  return (
    <>
      <div className="font-semibold">
        {intl.formatMessage({
          id: "sentry.feedback.title",
          defaultMessage: "Přidat informace k chybě",
        })}
      </div>
      {isSubmitSuccessful && !errors.root ? (
        <div className="text-sm text-green-700">
          {intl.formatMessage({
            id: "sentry.feedback.success",
            defaultMessage: "Děkujeme, informace byly odeslány podpoře.",
          })}
        </div>
      ) : (
        <>
          <TextField
            label={intl.formatMessage({
              id: "sentry.feedback.message",
              defaultMessage: "Popis chyby",
            })}
            multiline={true}
            name="message"
            rows={5}
            required={true}
          />
          <FileInputLayoutGroup
            accept="image/*"
            label={intl.formatMessage({
              id: "sentry.feedback.file",
              defaultMessage: "Vlastní screenshot (volitelné)",
            })}
            name="file"
          />
          {errors.root && (
            <div className="text-sm text-red-700">
              {intl.formatMessage({
                id: "sentry.feedback.error",
                defaultMessage: "Informace se nepodařilo odeslat.",
              })}
            </div>
          )}
          <Button type="submit" isLoading={isSubmitting}>
            {intl.formatMessage({
              id: "sentry.feedback.submit",
              defaultMessage: "Odeslat informace",
            })}
          </Button>
        </>
      )}
    </>
  );
}
